var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QMyClientsSubmenu'),_c('v-row',{staticClass:"mx-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('QCarrierPortalList',{attrs:{"agent":_vm.user.Agent}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }